import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private http : HttpClient,
    private sharedService : SharedService
  ) { }  

  
  private setHeaders(): HttpHeaders {
    const headersConfig: any = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Tenant-Id': 'DEFAULT_TENANT'
    };
    // if (this.sharedService.getToken()) {
    //   headersConfig['Authorization'] = `${'Bearer '}${this.sharedService.getToken()}`;
    // }
    return new HttpHeaders(headersConfig);
  }
  post(path: string, body: Object = {},options?:any): Observable<any> {
    return this.http.post(`${path}`, JSON.stringify(body), { headers: this.setHeaders(), ...options });
  }
  put(path: string, body: Object = {},options?:any): Observable<any> {
    return this.http.put(`${path}`, JSON.stringify(body), { headers: this.setHeaders(), ...options });
  }
  get(path: string, options?: any): Observable<any> {
    return this.http.get(`${path}`, { headers: this.setHeaders(), ...options });
  }
}
